import React from "react";
import { Alert } from "@mui/material";
import PageShell from "../PageShell";
import PageContainer from "./PageContainer";
import { useAuthStore } from "../store/authStore";
import { hasCedexAccess } from "../utils/roles";

// Route gate for the CEDEX pages: Admins and users granted the CEDEX role.
// The API enforces the same rule; this keeps everyone else from a page whose
// every request would be refused.
export default function RequireCedexAccess({ children }) {
  const user = useAuthStore((state) => state.user);
  if (hasCedexAccess(user)) return children;
  return (
    <PageShell>
      <PageContainer>
        <Alert severity="error" sx={{ mt: 2 }}>
          CEDEX requires the CEDEX role. Ask an administrator to grant it.
        </Alert>
      </PageContainer>
    </PageShell>
  );
}
